import React from 'react';

import { WarningDialog } from '../../components';
import ManualRestockDetails from './ManualRestockDetails';

const ManualRestockDialog = ({
	isOpen,
	setIsOpen,
	onClick,
	values = {},
	changeFormValue,
}) => (
	<WarningDialog
		title="Manual restock"
		isOpen={isOpen}
		setIsOpen={setIsOpen}
		leftButtonText="Manual restock"
		rightButtonText="Cancel"
		onClick={onClick}
		isButtonDisabled={!values.manualRestockComment}
	>
		<ManualRestockDetails values={values} changeFormValue={changeFormValue} />
	</WarningDialog>
);

export default ManualRestockDialog;
